import { createFileRoute } from "@tanstack/react-router";
import { StepFinal } from "@/features/vendor/onboarding/v1/step-final-submit";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-final-submit",
)({
  component: StepFinal,
});
